// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./UpdatePortfolio.css";

// const UpdatePortfolio = () => {
//   const [users, setUsers] = useState([]);
//   const [portfolio, setPortfolio] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

//   // Function to convert date to yyyy-mm-dd format for input[type="date"]
//   const formatDateForInput = (dateString) => {
//     if (!dateString) return new Date().toISOString().split("T")[0];

//     // If already in yyyy-mm-dd format, return as is
//     if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
//       return dateString;
//     }

//     // Try to parse the date and format it
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) {
//       return new Date().toISOString().split("T")[0];
//     }

//     return date.toISOString().split("T")[0];
//   };

//   // Function to format date for display (dd-mm-yyyy)
//   const formatDateForDisplay = (dateString) => {
//     if (!dateString) return "N/A";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "N/A";

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();

//     return `${day} - ${month} - ${year}`;
//   };

//   // Function to calculate derived values
//   const calculateDerivedValues = (
//     investedAmount,
//     withdrawal,
//     monthlyPnlPercentage
//   ) => {
//     const invested = parseFloat(investedAmount) || 0;
//     const withdrawalAmt = parseFloat(withdrawal) || 0;
//     const monthlyPnlPerc = parseFloat(monthlyPnlPercentage) || 0;

//     // Calculate This Month PNL
//     const thisMonthPnl = (invested * monthlyPnlPerc) / 100;

//     // Calculate Current Value
//     const currentValue = invested - withdrawalAmt + thisMonthPnl;

//     // Calculate Profit Percentage
//     const profitPercentage =
//       invested > 0
//         ? ((currentValue + withdrawalAmt - invested) / invested) * 100
//         : 0;

//     return {
//       thisMonthPnl: thisMonthPnl.toFixed(2),
//       currentValue: currentValue.toFixed(2),
//       profitPercentage: profitPercentage.toFixed(1),
//     };
//   };

//   const fetchUsers = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const response = await axios.get("/api/admin/users");
//       setUsers(response.data.users);
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to fetch users");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPortfolio = async (userId, user) => {
//     setLoading(true);
//     setError("");
//     setPortfolio([]);
//     setSelectedUser(user);

//     try {
//       const response = await axios.get(`/api/admin/portfolio/admin/${userId}`);

//       const portfolioWithMetrics = response?.data?.map((item) => {
//         const investedAmount = item?.investedAmount || 0;
//         const thismonthpnl = item?.thismonthpnl || 0;
//         const currentValue = item?.currentValue || 0;
//         const withdrawalAmt = item?.withdrawal || 0;

//         const monthlyPnlPercentage =
//           investedAmount > 0 ? (thismonthpnl / investedAmount) * 100 : 0;

//         const profitPercentage =
//           investedAmount > 0
//             ? ((currentValue + withdrawalAmt - investedAmount) /
//                 investedAmount) *
//               100
//             : 0;

//         return {
//           ...item,
//           investedAmount: item?.investedAmount?.toString() || "",
//           withdrawal: item?.withdrawal?.toString() || "",
//           currentValue: item?.currentValue?.toString() || "",
//           thismonthpnl: item?.thismonthpnl || "",
//           monthlyPnlPercentage: parseFloat(monthlyPnlPercentage.toFixed(1)),
//           profitPercentage: parseFloat(profitPercentage.toFixed(1)),
//           updatedDate:
//             item?.updatedDate || new Date().toISOString().split("T")[0],
//         };
//       });
//       setPortfolio(portfolioWithMetrics);
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to fetch portfolio data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePortfolioChange = (index, field, value) => {
//     const updatedPortfolio = [...portfolio];

//     // Validate numeric inputs
//     if (
//       field === "investedAmount" ||
//       field === "withdrawal" ||
//       field === "monthlyPnlPercentage"
//     ) {
//       if (value === "" || /^[-+]?\d*\.?\d*$/.test(value)) {
//         updatedPortfolio[index][field] = value;

//         // Calculate derived values when any of these fields change
//         const invested = updatedPortfolio[index].investedAmount || 0;
//         const withdrawal = updatedPortfolio[index].withdrawal || 0;
//         const monthlyPnlPerc =
//           updatedPortfolio[index].monthlyPnlPercentage || 0;

//         const derived = calculateDerivedValues(
//           invested,
//           withdrawal,
//           monthlyPnlPerc
//         );

//         updatedPortfolio[index].thismonthpnl = derived.thisMonthPnl;
//         updatedPortfolio[index].currentValue = derived.currentValue;
//         updatedPortfolio[index].profitPercentage = parseFloat(
//           derived.profitPercentage
//         );
//       }
//     } else if (field === "updatedDate") {
//       updatedPortfolio[index][field] = value;
//     }

//     setPortfolio(updatedPortfolio);
//   };

//   const handleBulkUpdate = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const token = localStorage.getItem("token");

//       // Prepare portfolio data with calculated values
//       const preparedPortfolio = portfolio.map((item) => {
//         // Recalculate to ensure accuracy before sending
//         const invested = parseFloat(item.investedAmount) || 0;
//         const withdrawalAmt = parseFloat(item.withdrawal) || 0;
//         const monthlyPnlPerc = parseFloat(item.monthlyPnlPercentage) || 0;

//         const derived = calculateDerivedValues(
//           invested,
//           withdrawalAmt,
//           monthlyPnlPerc
//         );

//         return {
//           ...item,
//           user: selectedUser._id,
//           investedAmount: invested,
//           withdrawal: withdrawalAmt,
//           currentValue: parseFloat(derived.currentValue),
//           thismonthpnl: parseFloat(derived.thisMonthPnl),
//           monthlyPnlPercentage: monthlyPnlPerc,
//           profitPercentage: parseFloat(derived.profitPercentage),
//           updatedDate: item.updatedDate,
//         };
//       });

//       await axios.put("/api/admin/portfolio/bulk-update", preparedPortfolio, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       toast.success("Portfolio updated successfully!");
//       setIsUpdateModalOpen(false);
//       setIsModalOpen(false);

//       // Refresh the portfolio data
//       if (selectedUser) {
//         await fetchPortfolio(selectedUser._id, selectedUser);
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to update portfolios");
//       toast.error(err.response?.data?.message || "Failed to update portfolios");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsUpdateModalOpen(false);
//     setPortfolio([]);
//     setSelectedUser(null);
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   return (
//     <>
//       <div className="portfolio-container-update-portfolio">
//         <h1>User Portfolio Management</h1>

//         {loading && <p>Loading data...</p>}
//         {error && <p className="error-message-update-portfolio">{error}</p>}

//         <table className="portfolio-table-update-portfolio">
//           <thead>
//             <tr>
//               <th>Username</th>
//               <th>Email</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map((user) => (
//               <tr key={user._id}>
//                 <td>{user.username}</td>
//                 <td>{user.email}</td>
//                 <td>
//                   <button
//                     className="btn-outline-update-portfolio"
//                     onClick={() => {
//                       fetchPortfolio(user._id, user);
//                       setIsModalOpen(true);
//                       setIsUpdateModalOpen(false);
//                     }}
//                   >
//                     View Portfolio
//                   </button>
//                   <button
//                     className="btn-primary-update-portfolio"
//                     onClick={() => {
//                       fetchPortfolio(user._id, user);
//                       setIsUpdateModalOpen(true);
//                       setIsModalOpen(false);
//                     }}
//                   >
//                     Update Portfolio
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* View Portfolio Modal */}
//         {isModalOpen && (
//           <div className="modal-overlay-update-portfolio">
//             <div className="modal-update-portfolio">
//               <h2>Portfolio Details for {selectedUser?.username}</h2>
//               <div className="table-container">
//                 <table>
//                   <thead>
//                     <tr>
//                       <th>Logo</th>
//                       <th>Name</th>
//                       <th>Invested</th>
//                       <th>Withdrawal</th>
//                       <th>Current Value</th>
//                       <th>This Month PNL</th>
//                       <th>Monthly PNL%</th>
//                       <th>Profit%</th>
//                       <th>Currency</th>
//                       <th>Updated Date</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {portfolio.map((row) => (
//                       <tr key={row._id}>
//                         <td>
//                           <img src={row.company.logo} alt="Logo" width={30} />
//                         </td>
//                         <td>{row.company.name}</td>
//                         <td>{row.investedAmount}</td>
//                         <td>{row.withdrawal}</td>
//                         <td>{row.currentValue}</td>
//                         <td>{row.thismonthpnl}</td>
//                         <td>{row.monthlyPnlPercentage}%</td>
//                         <td>{row.profitPercentage}%</td>
//                         <td>
//                           <img
//                             src={row.currency.symbol}
//                             alt="Logo"
//                             width={30}
//                           />
//                         </td>
//                         <td>{formatDateForDisplay(row.updatedDate)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="modal-actions">
//                 <button onClick={closeModal}>Close</button>
//               </div>
//             </div>
//           </div>
//         )}

//         <ToastContainer />
//       </div>
//       {/* Update Portfolio Modal */}
//       {isUpdateModalOpen && (
//         <div className="modal-overlay-update-portfolio">
//           <div className="modal-update-portfolio">
//             <h2>Update Portfolio for {selectedUser?.username}</h2>
//             <p className="calculation-note">
//               <strong>Note:</strong> Enter Invested, Withdrawal, and Monthly
//               PNL%.{" "}
//               <p>
//                 Current Value, This Month PNL, and Profit% will be calculated
//                 automatically.
//               </p>
//             </p>
//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Logo</th>
//                     <th>Name</th>
//                     <th>Invested</th>
//                     <th>Withdrawal</th>
//                     <th>Monthly PNL%</th>
//                     <th>Current Value</th>
//                     <th>This Month PNL</th>
//                     <th>Profit%</th>
//                     <th>Currency</th>
//                     <th>Updated Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {portfolio.map((row, index) => (
//                     <tr key={row._id}>
//                       <td>
//                         <img src={row.company.logo} alt="Logo" width={30} />
//                       </td>
//                       <td>{row.company.name}</td>
//                       <td>
//                         <input
//                           type="text"
//                           value={row.investedAmount}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "investedAmount",
//                               e.target.value
//                             )
//                           }
//                           className="input-update-portfolio"
//                           placeholder="0"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="text"
//                           value={row.withdrawal}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "withdrawal",
//                               e.target.value
//                             )
//                           }
//                           className="input-update-portfolio"
//                           placeholder="0"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="text"
//                           value={row.monthlyPnlPercentage || ""}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "monthlyPnlPercentage",
//                               e.target.value
//                             )
//                           }
//                           className="input-update-portfolio"
//                           placeholder="0"
//                         />
//                       </td>
//                       <td className="calculated-value">
//                         {row.currentValue || "0.00"}
//                       </td>
//                       <td className="calculated-value">
//                         {row.thismonthpnl || "0.00"}
//                       </td>
//                       <td className="calculated-value">
//                         {row.profitPercentage || "0.0"}%
//                       </td>
//                       <td>{row.currency.code}</td>
//                       <td>
//                         <input
//                           type="date"
//                           value={formatDateForInput(row.updatedDate)}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "updatedDate",
//                               e.target.value
//                             )
//                           }
//                           className="input-update-portfolio date-input"
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <div className="modal-actions">
//               <button
//                 onClick={handleBulkUpdate}
//                 className="btn-primary-update-portfolio"
//                 disabled={loading}
//               >
//                 {loading ? "Saving..." : "Save Changes"}
//               </button>
//               <button
//                 onClick={closeModal}
//                 className="btn-outline-update-portfolio"
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//             </div>
//             {error && <p className="error-message-update-portfolio">{error}</p>}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UpdatePortfolio;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./UpdatePortfolio.css";

const UpdatePortfolio = () => {
  const [users, setUsers] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  // Function to convert date to yyyy-mm-dd format for input[type="date"]
  const formatDateForInput = (dateString) => {
    if (!dateString) return new Date().toISOString().split("T")[0];

    // If already in yyyy-mm-dd format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    // Try to parse the date and format it
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return new Date().toISOString().split("T")[0];
    }

    return date.toISOString().split("T")[0];
  };

  // Function to format date for display (dd-mm-yyyy)
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day} - ${month} - ${year}`;
  };

  // Function to calculate derived values
  const calculateDerivedValues = (
    investedAmount,
    withdrawal,
    monthlyPnlPercentage,
    previousPnl
  ) => {
    const invested = parseFloat(investedAmount) || 0;
    const withdrawalAmt = parseFloat(withdrawal) || 0;
    const monthlyPnlPerc = parseFloat(monthlyPnlPercentage) || 0;
    const previousPnlAmt = parseFloat(previousPnl) || 0;

    // Calculate This Month PNL
    const thisMonthPnl = (invested * monthlyPnlPerc) / 100;

    // Calculate Current Value (including previous PNL)
    const currentValue =
      invested - withdrawalAmt + thisMonthPnl + previousPnlAmt;

    // Calculate Profit Percentage
    const profitPercentage =
      invested > 0
        ? ((currentValue + withdrawalAmt - invested) / invested) * 100
        : 0;

    return {
      thisMonthPnl: thisMonthPnl.toFixed(2),
      currentValue: currentValue.toFixed(2),
      profitPercentage: profitPercentage.toFixed(1),
    };
  };

  const fetchUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get("/api/admin/users");
      setUsers(response.data.users);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  const fetchPortfolio = async (userId, user) => {
    setLoading(true);
    setError("");
    setPortfolio([]);
    setSelectedUser(user);

    try {
      const response = await axios.get(`/api/admin/portfolio/admin/${userId}`);

      const portfolioWithMetrics = response?.data?.map((item) => {
        const investedAmount = item?.investedAmount || 0;
        const thismonthpnl = item?.thismonthpnl || 0;
        const currentValue = item?.currentValue || 0;
        const withdrawalAmt = item?.withdrawal || 0;
        const previousPnl = item?.previousPnl || 0;

        const monthlyPnlPercentage =
          investedAmount > 0 ? (thismonthpnl / investedAmount) * 100 : 0;

        const profitPercentage =
          investedAmount > 0
            ? ((currentValue + withdrawalAmt - investedAmount) /
                investedAmount) *
              100
            : 0;

        return {
          ...item,
          investedAmount: item?.investedAmount?.toString() || "",
          withdrawal: item?.withdrawal?.toString() || "",
          currentValue: item?.currentValue?.toString() || "",
          thismonthpnl: item?.thismonthpnl || "",
          previousPnl: item?.previousPnl?.toString() || "0",
          monthlyPnlPercentage: parseFloat(monthlyPnlPercentage.toFixed(1)),
          profitPercentage: parseFloat(profitPercentage.toFixed(1)),
          updatedDate:
            item?.updatedDate || new Date().toISOString().split("T")[0],
        };
      });
      setPortfolio(portfolioWithMetrics);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch portfolio data");
    } finally {
      setLoading(false);
    }
  };

  const handlePortfolioChange = (index, field, value) => {
    const updatedPortfolio = [...portfolio];

    // Validate numeric inputs
    if (
      field === "investedAmount" ||
      field === "withdrawal" ||
      field === "monthlyPnlPercentage" ||
      field === "previousPnl"
    ) {
      if (value === "" || /^[-+]?\d*\.?\d*$/.test(value)) {
        updatedPortfolio[index][field] = value;

        // Calculate derived values when any of these fields change
        const invested = updatedPortfolio[index].investedAmount || 0;
        const withdrawal = updatedPortfolio[index].withdrawal || 0;
        const monthlyPnlPerc =
          updatedPortfolio[index].monthlyPnlPercentage || 0;
        const previousPnlAmt = updatedPortfolio[index].previousPnl || 0;

        const derived = calculateDerivedValues(
          invested,
          withdrawal,
          monthlyPnlPerc,
          previousPnlAmt
        );

        updatedPortfolio[index].thismonthpnl = derived.thisMonthPnl;
        updatedPortfolio[index].currentValue = derived.currentValue;
        updatedPortfolio[index].profitPercentage = parseFloat(
          derived.profitPercentage
        );
      }
    } else if (field === "updatedDate") {
      updatedPortfolio[index][field] = value;
    }

    setPortfolio(updatedPortfolio);
  };

  const handleBulkUpdate = async () => {
    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      // Prepare portfolio data with calculated values
      const preparedPortfolio = portfolio.map((item) => {
        // Recalculate to ensure accuracy before sending
        const invested = parseFloat(item.investedAmount) || 0;
        const withdrawalAmt = parseFloat(item.withdrawal) || 0;
        const monthlyPnlPerc = parseFloat(item.monthlyPnlPercentage) || 0;
        const previousPnlAmt = parseFloat(item.previousPnl) || 0;

        const derived = calculateDerivedValues(
          invested,
          withdrawalAmt,
          monthlyPnlPerc,
          previousPnlAmt
        );

        return {
          ...item,
          user: selectedUser._id,
          investedAmount: invested,
          withdrawal: withdrawalAmt,
          currentValue: parseFloat(derived.currentValue),
          thismonthpnl: parseFloat(derived.thisMonthPnl),
          previousPnl: previousPnlAmt,
          monthlyPnlPercentage: monthlyPnlPerc,
          profitPercentage: parseFloat(derived.profitPercentage),
          updatedDate: item.updatedDate,
        };
      });

      await axios.put("/api/admin/portfolio/bulk-update", preparedPortfolio, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Portfolio updated successfully!");
      setIsUpdateModalOpen(false);
      setIsModalOpen(false);

      // Refresh the portfolio data
      if (selectedUser) {
        await fetchPortfolio(selectedUser._id, selectedUser);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to update portfolios");
      toast.error(err.response?.data?.message || "Failed to update portfolios");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsUpdateModalOpen(false);
    setPortfolio([]);
    setSelectedUser(null);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      <div className="portfolio-container-update-portfolio">
        <h1>User Portfolio Management</h1>

        {loading && <p>Loading data...</p>}
        {error && <p className="error-message-update-portfolio">{error}</p>}

        <table className="portfolio-table-update-portfolio">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>
                  <button
                    className="btn-outline-update-portfolio"
                    onClick={() => {
                      fetchPortfolio(user._id, user);
                      setIsModalOpen(true);
                      setIsUpdateModalOpen(false);
                    }}
                  >
                    View Portfolio
                  </button>
                  <button
                    className="btn-primary-update-portfolio"
                    onClick={() => {
                      fetchPortfolio(user._id, user);
                      setIsUpdateModalOpen(true);
                      setIsModalOpen(false);
                    }}
                  >
                    Update Portfolio
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* View Portfolio Modal */}
        {isModalOpen && (
          <div className="modal-overlay-update-portfolio">
            <div className="modal-update-portfolio">
              <h2>Portfolio Details for {selectedUser?.username}</h2>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Logo</th>
                      <th>Name</th>
                      <th>Invested</th>
                      <th>Withdrawal</th>
                      <th>Current Value</th>
                      <th>This Month PNL</th>
                      <th>Previous PNL</th>
                      <th>Monthly PNL%</th>
                      <th>Profit%</th>
                      <th>Currency</th>
                      <th>Updated Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {portfolio.map((row) => (
                      <tr key={row._id}>
                        <td>
                          <img src={row.company.logo} alt="Logo" width={30} />
                        </td>
                        <td>{row.company.name}</td>
                        <td>{row.investedAmount}</td>
                        <td>{row.withdrawal}</td>
                        <td>{row.currentValue}</td>
                        <td>{row.thismonthpnl}</td>
                        <td>{row.previousPnl || "0"}</td>
                        <td>{row.monthlyPnlPercentage}%</td>
                        <td>{row.profitPercentage}%</td>
                        <td>
                          <img
                            src={row.currency.symbol}
                            alt="Logo"
                            width={30}
                          />
                        </td>
                        <td>{formatDateForDisplay(row.updatedDate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="modal-actions">
                <button onClick={closeModal}>Close</button>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
      </div>
      {/* Update Portfolio Modal */}
      {isUpdateModalOpen && (
        <div className="modal-overlay-update-portfolio">
          <div className="modal-update-portfolio">
            <h2>Update Portfolio for {selectedUser?.username}</h2>
            <p className="calculation-note">
              <strong>Note:</strong> Enter Invested, Withdrawal, Monthly PNL%,
              and Previous PNL.{" "}
              <p>
                Current Value, This Month PNL, and Profit% will be calculated
                automatically.
              </p>
            </p>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Logo</th>
                    <th>Name</th>
                    <th>Invested</th>
                    <th>Withdrawal</th>
                    <th>Monthly PNL%</th>
                    <th>Previous PNL</th>
                    <th>Current Value</th>
                    <th>This Month PNL</th>
                    <th>Profit%</th>
                    <th>Currency</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                  {portfolio.map((row, index) => (
                    <tr key={row._id}>
                      <td>
                        <img src={row.company.logo} alt="Logo" width={30} />
                      </td>
                      <td>{row.company.name}</td>
                      <td>
                        <input
                          type="text"
                          value={row.investedAmount}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "investedAmount",
                              e.target.value
                            )
                          }
                          className="input-update-portfolio"
                          placeholder="0"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.withdrawal}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "withdrawal",
                              e.target.value
                            )
                          }
                          className="input-update-portfolio"
                          placeholder="0"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.monthlyPnlPercentage || ""}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "monthlyPnlPercentage",
                              e.target.value
                            )
                          }
                          className="input-update-portfolio"
                          placeholder="0"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.previousPnl || ""}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "previousPnl",
                              e.target.value
                            )
                          }
                          className="input-update-portfolio"
                          placeholder="0"
                        />
                      </td>
                      <td className="calculated-value">
                        {row.currentValue || "0.00"}
                      </td>
                      <td className="calculated-value">
                        {row.thismonthpnl || "0.00"}
                      </td>
                      <td className="calculated-value">
                        {row.profitPercentage || "0.0"}%
                      </td>
                      <td>{row.currency.code}</td>
                      <td>
                        <input
                          type="date"
                          value={formatDateForInput(row.updatedDate)}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "updatedDate",
                              e.target.value
                            )
                          }
                          className="input-update-portfolio date-input"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-actions">
              <button
                onClick={handleBulkUpdate}
                className="btn-primary-update-portfolio"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Changes"}
              </button>
              <button
                onClick={closeModal}
                className="btn-outline-update-portfolio"
                disabled={loading}
              >
                Cancel
              </button>
            </div>
            {error && <p className="error-message-update-portfolio">{error}</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default UpdatePortfolio;
